import React, { useState, useEffect } from 'react';
 
import expand from '../../../assets/expand.svg';
 
import collapse from '../../../assets/collapse.svg';
 
import { useNavigate } from "react-router-dom";
 
import './menu.css';
 
//import { navData } from "../navData/navData";
 
import MenuIcon from '@mui/icons-material/Menu';
 
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
 
import { NavLink } from "react-router-dom";
 
import { Button } from "@mui/material";
import GridViewIcon from '@mui/icons-material/GridView';
import LogoutIcon from '@mui/icons-material/Logout';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import LockResetIcon from '@mui/icons-material/LockReset';
import ListIcon from '@mui/icons-material/List';
import PersonAddAltRoundedIcon from '@mui/icons-material/PersonAddAltRounded';
import EditNoteIcon from '@mui/icons-material/EditNote';
sessionStorage.setItem("active", '');
 
const navData =
[
    {
        id: 0,
        icon: <GridViewIcon/>,
        text: "Dashboard",
        link: "/dashboard",
    },
    {
        id: 1,
        icon: <CloudUploadIcon/>,
        text: "Experiment",
        link: "/home",
    },
    {
        id: 2,
        icon: <LockResetIcon/>,
        text: "Password",
        link: "/changepassword"
    },
    {
        id: 3,
        icon: <PersonAddAltRoundedIcon/>,
        text: "Create User",
        link: "/createuser",
    },
    {
        id: 4,
        icon: <ListIcon/>,
        text: "List of User",
        link: "/userdashboard",
    },
    {
        id: 5,
        icon: <EditNoteIcon/>,
        text: "Company Details",
        link: "/companydetails"
    }
]
 
 
// MainMenu
 
export default function MainMenu() {
 
    const [open, setopen] = useState(true);
 
    const [menuActive, setMenuActive] = useState("sideitem");
 
    var user = JSON.parse(sessionStorage.getItem("idToken"));
 
    var navMenu = [];
 
    var setMenu = 'sideitem active';
 
    var productlink = sessionStorage.getItem("clickedInstrument");
 
 
 
    const [updatedNavMenu, setNavMenu] = useState()
 
 
 
    // Define selectedAction and storedValue here
    var selectedAction;
    //const selectedAction = sessionStorage.getItem('clickedType') || "Product";
    const adminValueCheck = sessionStorage.getItem('adminCheck') ;
    if(adminValueCheck === "true")
        {
            selectedAction = "Admin";
        }
    else if(adminValueCheck === "false"){
        selectedAction = "User";
    }  
    //alert(selectedAction)
    //const storedValue = sessionStorage.getItem('clickedValue') || "Dashboard";
 
 
 
    navData.forEach(value => {
 
        if (user && user.payload.nickname === "Bio-Rad") {
 
            if (value.text !== "Experiment") {
 
                if (productlink === "ddSEQ") {
 
                    if (value.text === "Dashboard") {
 
                        value.link = "/dashboard";
 
                    }
 
                    navMenu.push(value);
 
                }
 
                if (productlink === "Genesis") {
 
                    if (value.text === "Dashboard") {
 
                        value.link = "/genesisdashboard";
 
                    }
 
                    navMenu.push(value);
 
                }
 
                if (productlink === "SEQuoia") {
 
                    if (value.text === "Dashboard") {
 
                        value.link = "/dashboardsequoia";
 
                    }
 
                    navMenu.push(value);
 
                }
 
            }
 
        } else {
 
            if (productlink === "ddSEQ") {
 
                if (value.text === "Dashboard") {
 
                    value.link = "/dashboard";
 
                }
 
                if (value.text === "Experiment") {
 
                    value.link = "/home";
 
                }
 
                navMenu.push(value);
 
            }
 
            if (productlink === "Genesis") {
 
                if (value.text === "Dashboard") {
 
                    value.link = "/genesisdashboard";
 
                }
 
                if (value.text === "Experiment") {
 
                    value.link = "/genesishome";
 
                }
 
                navMenu.push(value);
 
            }
 
            if (productlink === "SEQuoia") {
 
                if (value.text === "Dashboard") {
 
                    value.link = "/dashboardsequoia";
 
                }
 
                if (value.text === "Experiment") {
 
                    value.link = "/sequoiahome";
 
                }
 
                navMenu.push(value);
 
            }
 
            if (productlink === "New User") {
 
                if (value.text === "Create User") {
 
                    value.link = "/createuser";
 
                }
 
                if (value.text === "listOfUser") {
 
                    value.link = "/userdashboard";
 
                }
 
            }
 
        }
 
    });
 
 
 
    const changeMenu = (event) => {
 
        console.log(event);
 
        if (user.payload.nickname === "Bio-Rad") {
 
            if (event.target.innerText === "Dashboard") {
 
                setMenuActive("sideitem active");
 
            } else {
 
                setMenuActive("sideitem");
 
            }
 
        } else {
 
            setMenuActive("sideitem");
 
        }
 
    }
 
 
 
    const toggleOpen = () => {
 
        setopen(!open);
 
    }
 
 
 
    useEffect(() => {
        // Update the "enabled" property of each menu item based on the selected action
       
        const updatedNavMenu = navData.map(item => {
          switch (selectedAction) {
            case "Admin":
              // Enable/disable menu items based on the selected action
              item.enabled = ["Dashboard", "Experiment", "Password","Create User", "List of User", "Company Details"].includes(item.text);
              break;
            case "User":
              // Enable/disable menu items based on the selected action
              item.enabled = ["Dashboard", "Experiment", "Password"].includes(item.text);
              break;
            default:
              item.enabled = true; // Enable all items by default
              break;
          }
          return item;
        });
        // Set the updated menu items
        setNavMenu(updatedNavMenu);
      }, [selectedAction]);
 
 
 
    return (
 
        <div className={open ? 'sidenav' : 'sidenavClosed'}>
        <Button className='menuBtn' onClick={toggleOpen} style={{ marginLeft: 200 }}>
                {open ? <MenuOpenIcon /> : <MenuIcon style={{ marginLeft: -400 }} />}
        </Button>
              {navMenu.map(item => (
                item.enabled ? (
        <NavLink key={item.id} onClick={changeMenu} className={`sideitem ${item.enabled ? 'enabled' : 'disabled'}`} to={item.link}>
                    {item.icon}
        <span className='linkText' style={{ color: "#027620" }}>{item.text}</span>
        </NavLink>
                ) : null // Don't render disabled menu items
              ))}
        </div>
 
    );
 
}